import { ReactNode, memo, useEffect, useState } from 'react'
import _ from 'underscore'
import { FoundationsRequest, getBaseUrl } from '../../Utils'
import moment from 'moment'
import { Status, RequestStatus, PriorityCodes, tzMap } from '../../Redux/WLM/wlmEnums'
import { useSelector, useDispatch } from 'react-redux'
import { selectField } from '../../Redux/WLM/wlmSelectors'
import { onEnter } from '../../GlobalMethods'

declare let window: any

const WlmListCompo = memo((props: { status: string }) => {
    // TODO handle reload on sites!
    const dispatch = useDispatch()
    const permittedSites = useSelector(selectField('permittedSites'))
    const selectedItem = useSelector(selectField('selectedItem'))
    const permissions = useSelector(selectField('permissions'))
    const dayOfWeeks = useSelector(selectField('dayOfWeeks'))
    const showSite = useSelector(selectField('showSite'))
    const priorities = useSelector(selectField('priorities')) || []
    const requestType = useSelector(selectField('requestType')) || []
    const modalities = useSelector(selectField('modalities')) || []
    const modalityCounts = useSelector(selectField('modalityCounts')) || []
    const listReload = useSelector(selectField('listReload'))
    // const pickedRowId = useSelector(selectField('pickedRowId'));
    const [listContent, setListContent] = useState([])
    const [searchField, setSearchField] = useState('')
    const [filtered, setFiletered] = useState([])

    useEffect(() => {
        setFiletered(
            listContent.filter(function (item: {
                effectiveRequesterLastName: string
                id: { toString: () => string }
                siteName: string
                requestSummary: string
                comment: string
                startingDateTime: any
                TZCode: string
                endingDateTime: any
            }) {
                return (
                    hasIt(item.effectiveRequesterLastName) ||
                    hasIt(item.id.toString()) ||
                    hasIt(item.siteName) ||
                    hasIt(item.requestSummary) ||
                    hasIt(item.comment) ||
                    hasIt(utcToLocal(item.startingDateTime, item.TZCode, true)[0]) ||
                    hasIt(utcToLocal(item.endingDateTime, item.TZCode, true)[0]) ||
                    hasIt(item.TZCode)
                )
            })
        )
    }, [searchField, listContent])

    const toDate = (input: string | number | Date) => {
        return new Date(input)
    }
    const loadItems = (statusCode: string, onLoaded: (arg0: any) => void) => {
        const validSiteIds = permittedSites
            .map((siteItem: { Id: any }) => siteItem.Id)
            .filter((id: number) => id !== -1); // Filter out invalid IDs
     
        if (validSiteIds.length === 0) {
            return; // Don't make the API call if there's nothing valid to send
        }
        FoundationsRequest('POST', {
            url: getBaseUrl() + 'API/v3/wlm/list/' + statusCode,
            data: validSiteIds,
            cache: false,
            includeTokenHeader:true,
            success: function (response: { data: any; id: string }) {
                // dates come in as Strings from the backend. Make them usable in JS as Date
                response.data.forEach(function (item: {
                    ts_modificationDateTime: any
                    ts_creationDateTime: any
                }) {
                    item.ts_modificationDateTime = toDate(item.ts_modificationDateTime)
                    item.ts_creationDateTime = toDate(item.ts_creationDateTime)
                })
                onLoaded(response.data)
            },
            error: function (error: { Message: string }) {
                dispatch({
                    type: 'wlm/set-statusMessage',
                    payload: 'Failed to load the lists. ' + error.Message,
                })
                // TODO messageasync
                // setMessageAsynch(statusAsynch(statusMessage))
                dispatch({ type: 'wlm/set-statusType', payload: Status.ERROR })
            },
        })
    }

    useEffect(() => {
        if (permittedSites.length > 0) {
            loadItems(props.status, (list) => {
                setListContent(list)
            })
        }
    }, [permittedSites, listReload])

    // const reload = () => {
    //     loadItems(props.status, function (list: any) {
    //         var tempLists = lists
    //         tempLists[props.status] = list
    //         dispatch({ type: 'wlm/set-lists', payload: tempLists })
    //     })
    // }

    const getOrDefaultDateStr = (val: number, tzCode: string) => {
        if (!val) {
            val = new Date().getTime()
        }
        if (!tzCode) tzCode = moment.tz.guess()
        var f = utcToLocal(val, tzCode, false)
        return f[0]
    }

    const utcToLocal = (utc: string | number, tzCode: string, disp: boolean) => {
        var res = []
        var zone = tzCode.indexOf('/') > 0 ? tzCode : tzMap[tzCode]
        if (utc !== undefined && typeof utc === 'string' && utc.slice(-1) !== 'Z') utc += 'Z' //FP-9915 make sure utc will be parsed as a UTC date
        var utcDate = new Date(utc)
        utc = utcDate.toLocaleString('en-US', { timeZone: zone })
        var u = moment.utc(utc)
        if (!u) {
            return ['0000-00-00', 'ERR', '']
        }
        if (disp) res[0] = u.format('ddd MM/DD/YYYY')
        else if (utc.indexOf('-') > 0) res[0] = u.format('YYYY-MM-DD')
        else res[0] = u.format('MM/DD/YYYY')
        res[1] = u.format('HH:mm')
        res[2] = zone ? tzCode : 'UTC*'
        return res
    }

    const fetchOneRequest = (
        recordId: number,
        onLoaded: (arg0: {
            ts_modificationDateTime: string | Date
            ts_creationDateTime: string | Date
            reqMon: string
            reqTue: string
            reqWed: string
            reqThu: string
            reqFri: string
            reqSat: string
            reqSun: string
            PF_Count: number
            CT_Count: number
            MR_Count: number
            US_Count: number
            OT_Count: number
            MG_Count: number
        }) => void
    ) => {
        // konsole.log(`Called: loadOneItem(${recordId})`);
        var printDow = function (p: {
            reqMon: string
            reqTue: string
            reqWed: string
            reqThu: string
            reqFri: string
            reqSat: string
            reqSun: string
        }) {
            var msg =
                'Loaded: Mon:' +
                p.reqMon +
                ', Tue:' +
                p.reqTue +
                ', Wed:' +
                p.reqWed +
                ', Thu:' +
                p.reqThu +
                ', Fri:' +
                p.reqFri +
                ', Sat:' +
                p.reqSat +
                ', Sun:' +
                p.reqSun
        }

        if (recordId <= 0) {
            dispatch({
                type: 'wlm/set-statusMessage',
                payload: 'Problem selecting the request record. Internal error.',
            })
            return
        }
        FoundationsRequest('GET', {
            url: getBaseUrl() + 'API/v3/wlm/wlmrecord/' + recordId,
            cache: false,
            includeTokenHeader:true,
            success: (response: {
                data: {
                    ts_modificationDateTime: string | Date
                    ts_creationDateTime: string | Date
                    reqMon: string
                    reqTue: string
                    reqWed: string
                    reqThu: string
                    reqFri: string
                    reqSat: string
                    reqSun: string
                    PF_Count: number
                    CT_Count: number
                    MR_Count: number
                    US_Count: number
                    OT_Count: number
                    MG_Count: number
                }
            }) => {
                var item = response.data
                item.ts_modificationDateTime = toDate(item.ts_modificationDateTime)
                item.ts_creationDateTime = toDate(item.ts_creationDateTime)
                printDow(response.data)
                onLoaded(response.data)
                // var vus = window.healthLevelWorkspaceVU.userVisualUnitsInfo
                // var workloadrequestId = vus.find(
                //     (vu: { AppGUID: string }) => vu.AppGUID === 'guidfor_workloadrequestform'
                // )
                // if (
                //     $('#link_dashboard_vu_expand_' + workloadrequestId.VisualUnitId).css(
                //         'display'
                //     ) == 'inline'
                // ) {
                //     $('#link_dashboard_vu_expand_' + workloadrequestId.VisualUnitId).click()
                // }
            },
            error: (error: { Message: string }) => {
                var msg = 'Failed to load the latest record. ' + error.Message
                dispatch({ type: 'wlm/set-statusMessage', payload: msg })
                // TODO asynch
                // self.messageAsynch = self.statusAsynch(self.statusMessage());
                dispatch({ type: 'wlm/set-setStatusType', payload: Status.ERROR })
            },
        })
    }

    const getOrDefaultStr = (val: string) => {
        if (!val) val = ''
        return val
    }

    const getOrDefaultTimeStr = (val: number, tzCode: string) => {
        if (!val) {
            val = new Date().getTime()
        }
        if (!tzCode) tzCode = moment.tz.guess()
        var f = utcToLocal(val, tzCode, false)
        return f[1]
    }

    const selectedCallback = function (elemId: string) {
        const frags = elemId.split('.')
        const id = Number(frags[2])
        const list = listContent
        const sel = list.find(function (item: { id: number }) {
            return item.id === id
        })

        // dispatch({ type: 'wlm/set-selectedItem', payload: sel })
        fetchOneRequest(id, function (fetched) {
            dispatch({ type: 'wlm/set-selectedItem', payload: fetched })
            onSelected(fetched)
        })
    }

    const loadComments = (requestId: string) => {
        FoundationsRequest('GET', {
            url: getBaseUrl() + 'API/v3/wlm/comments/' + requestId,
            cache: false,
            includeTokenHeader:true,
            success: function (response: { data: any; id: string }) {
                dispatch({ type: 'wlm/set-comments', payload: response.data })
            },
        })
    }

    const onSelected = (selected: {
        ts_modificationDateTime?: string | Date
        ts_creationDateTime?: string | Date
        reqMon: any
        reqTue: any
        reqWed: any
        reqThu: any
        reqFri: any
        reqSat: any
        reqSun: any
        PF_Count: number
        CT_Count: number
        MR_Count: number
        US_Count: number
        OT_Count: number
        MG_Count: number
        requestStatus?: any
        id?: any
        priority?: any
        requestType?: any
        startingDateTime?: any
        TZCode?: any
        endingDateTime?: any
        siteName?: any
    }) => {
        // var selected = selectedItem
        // if (permissions.CanDecline) selected.requestStatus = RequestStatus.inReview
        var dow = dayOfWeeks
        dispatch({ type: 'wlm/set-requestId', payload: selected.id })
        dow[0] = selected.reqMon
        dow[1] = selected.reqTue
        dow[2] = selected.reqWed
        dow[3] = selected.reqThu
        dow[4] = selected.reqFri
        dow[5] = selected.reqSat
        dow[6] = selected.reqSun
        dow[7] = false

        const tempPriorities = priorities.map((_: any) => false)
        tempPriorities[selected.priority - 1] = true
        dispatch({ type: 'wlm/set-priorities', payload: tempPriorities })
        const tempRequestType = requestType.map((_: any) => false)
        tempRequestType[selected.requestType] = true
        dispatch({ type: 'wlm/set-requestType', payload: tempRequestType })

        var startingDate = getOrDefaultDateStr(selected.startingDateTime, selected.TZCode),
            startingTime = getOrDefaultTimeStr(selected.startingDateTime, selected.TZCode),
            endingDate = getOrDefaultDateStr(selected.endingDateTime, selected.TZCode),
            endingTime = getOrDefaultTimeStr(selected.endingDateTime, selected.TZCode)
        dispatch({ type: 'wlm/set-startingDate', payload: startingDate })
        dispatch({ type: 'wlm/set-startingTime', payload: startingTime })
        dispatch({ type: 'wlm/set-endingDate', payload: endingDate })
        dispatch({ type: 'wlm/set-endingTime', payload: endingTime })
        dispatch({ type: 'wlm/set-selectedSite', payload: selected.id })
        dispatch({ type: 'wlm/set-selectedSiteName', payload: selected.siteName })
        dispatch({ type: 'wlm/set-selectedSiteTz', payload: selected.TZCode })
        dispatch({ type: 'wlm/set-selectedItem', payload: selected })
        dispatch({ type: 'wlm/set-statusMessage', payload: '' })
        dispatch({ type: 'wlm/set-allowSitePick', payload: false })
        loadComments(selected.id)
        loadModalities(selected)
        // Hack to scroll the screen to top. This may not be desirable
        window.scrollTo(0, 250)
    }

    const loadModalities = (counts: {
        PF_Count: any
        CT_Count: any
        MR_Count: any
        US_Count: any
        OT_Count: any
        MG_Count: any
    }) => {
        if (!modalityCounts || modalityCounts.length === 0) {
            const tempModalityCounts: number[] = modalities.map((_: any) => 0)
            dispatch({ type: 'wlm/set-modalityCounts', payload: tempModalityCounts })
        }
        const tempModalityCounts = [...modalityCounts]
        modalities.forEach((modality: any, index: number) => {
            switch (modality) {
                case 'PF':
                case 'DX':
                    tempModalityCounts[index] = counts.PF_Count
                    break
                case 'CT':
                    tempModalityCounts[index] = counts.CT_Count
                    break
                case 'MR':
                    tempModalityCounts[index] = counts.MR_Count
                    break
                case 'US':
                    tempModalityCounts[index] = counts.US_Count
                    break
                case 'OT':
                    tempModalityCounts[index] = counts.OT_Count
                    break
                case 'MG':
                    tempModalityCounts[index] = counts.MG_Count
                    break
            }
        })
        dispatch({ type: 'wlm/set-modalityCounts', payload: tempModalityCounts })
    }

    const hasIt = (field: string) => {
        if (searchField !== undefined && searchField !== '') {
            if (!field) return false
            var s = field.toLowerCase()
            var ma = s.match('' + searchField.toLowerCase())
            if (ma && ma.length > 0) return true
            return false
        }
        return true
    }

    return (
        <>
            <div style={{ padding: '5px' }}>
                <label>Find:</label>
                <input
                    type="search"
                    style={{ width: '90%' }}
                    value={searchField}
                    onInput={(event) => {
                        setSearchField(event.currentTarget.value)
                    }}
                    onKeyDown={(event) =>
                        onEnter(event, () => setSearchField(event.currentTarget.value))
                    }
                />
            </div>
            <table className="wlgridtable tablesorter w-100" style={{ fontSize: '11px' }}>
                <thead>
                    <tr className='table-header-wordbreak'>
                        <th>REQ ID</th>
                        {showSite ? <th>Site</th> : <></>}
                        <th>Priority</th>
                        <th>Requester</th>
                        <th>Age</th>
                        <th>Start </th> <th>End </th> <th>Zone </th> <th>Summary </th>{' '}
                        <th>Notes </th> <th>Evaluated By </th> <th>Actions</th>
                    </tr>
                </thead>
                {filtered.map(
                    (row: {
                        siteName: ReactNode
                        priorityName: ReactNode
                        effectiveRequesterLastName: any
                        effectiveReqesterFirstName: string
                        Age: ReactNode
                        requestSummary: ReactNode
                        comment: ReactNode
                        ApproverLastName: any
                        ApproverFirstName: string
                        id: string
                        TZCode: string | undefined
                        startingDateTime: string | number
                        endingDateTime: string | number
                    }) => {
                        const rowId = 'wml.' + props.status + '.' + row.id
                        if (row.TZCode != undefined && row.TZCode != '') {
                            const startDt = utcToLocal(row.startingDateTime, row.TZCode, true),
                                endDt = utcToLocal(row.endingDateTime, row.TZCode, true)
                            return (
                                <tr
                                    id={rowId}
                                    className={`wlmRow ${row.id == selectedItem.id ? 'selected' : ''}`}
                                >
                                    <td>{row.id.toString()}</td>
                                    {showSite ? <td>{row.siteName}</td> : <></>}
                                    <td>{row.priorityName}</td>
                                    <td>
                                        {row.effectiveRequesterLastName
                                            ? row.effectiveRequesterLastName +
                                              ', ' +
                                              row.effectiveReqesterFirstName
                                            : ''}
                                    </td>
                                    <td>{row.Age}</td>
                                    <td>{startDt[0] + ' ' + startDt[1]}</td>
                                    <td>{endDt[0] + ' ' + endDt[1]}</td>
                                    <td>{startDt[2]}</td>
                                    <td>{row.requestSummary}</td>
                                    <td className='wrap-and-break' style={{maxWidth:'200px'}}>{row.comment}</td>
                                    <td>
                                        {row.ApproverLastName
                                            ? row.ApproverLastName + ', ' + row.ApproverFirstName
                                            : ''}
                                    </td>
                                    <td>
                                        <a
                                            id="viewId"
                                            href="javascript:void(0)"
                                            onClick={function (event) {
                                                event.stopPropagation()
                                                // dispatch({ type: 'wlm/set-pickedRowId', payload: rowId })
                                                // setPickedElement(currentRow)
                                                selectedCallback(rowId)
                                                // eventCallbacks(event, rowId)
                                            }}
                                        >
                                            View
                                        </a>
                                    </td>
                                </tr>
                            )
                        } else {
                            return (
                                <tr id={rowId} style={{ background: '#FCDEDF' }}>
                                    <td colSpan={12}>
                                        {' '}
                                        - Site {showSite ? row.siteName : ''} with Reg ID{' '}
                                        {row.id.toString()} is missing a time zone code and could
                                        not be rendered -
                                    </td>
                                </tr>
                            )
                        }
                    }
                )}
            </table>
        </>
    )
})

export default WlmListCompo
